import React, { Component } from 'react';
import Table from '../../components/Table';
import {Toast,Flex,List, Stepper,Radio} from 'antd-mobile';
import send from '../../utils/send';
import {FARM_ORG, ORG_CODE} from '../../cache';
import LinkText from './components/link';
import MateGroup from './components/mate-group';
import Breeder from './components/breeder';
import EmptyReport from '../../components/EmptyReport'
/*
1. 表头：根据相隔天数形成。headers1 和 headers2形成的差是用户输入的相隔天数。
* 梯状形成: 查询结果的配种组开始天数 a - 今日 b = 算出相隔天数 c， 当对应列headers1[i] > c
*的时候，则不显示该行。如此，可形成梯状图。
* */
let headers1 = [];
let headers2 = [];
let showHeaderFlag = [];
let breedersSource = [];
let birthWeekSource = [];
export default class Report04 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showBreeder: false,
      showStart: false,
      showEnd: false,
      startWeek: '',
      endWeek: '',
      startDate: null,
      endDate: null,
      status: 'pregnant',// 怀孕pregnant，未怀孕： noPregnant
      parGestation: 115,
      parity: 'ALL',
      dayArr: [
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'},
        {day: '7'}
      ],
      selectedBreeder: '',
      resData: [], // 后台返回的数据
      tableData: [], // 经过处理后表格要显示的数据
      columns: [
        {
          id: 'mate_group',
          title: '',
          fixed: true,
          align: 'left',
          render (d) {
            return <div style={{width: 50}}>{d.mate_group}</div>
          }
        }
      ]
    }
  }
  async componentDidMount() {
    let breed = await send({
      url: '/api/forward/ifarm/breedTypeByOrg',
      method: 'GET',
      params: {
        orgCode: ORG_CODE
      }
    });
    let birthWeek = await send({
      url: '/api/forward/ifarm/getWeekYearly',
      method: 'GET'
    });
    // 获取品种， 周次的信息，并默认初始值。得到之后，查询。
    breedersSource = breed.data.filter(o => o.PRODUCTID !== 'TOTAL');
    birthWeekSource = birthWeek.data;
    this.setState({
      selectedBreeder: breedersSource.map(o => o.PRODUCTID),
      allBreed: 'ALL',
      startWeek: birthWeekSource[0].mateGroup,
      startDate: birthWeekSource[0].weekStartDate,
      endWeek: birthWeekSource[0].mateGroup,
      endDate: birthWeekSource[0].weekEndDate
    }, () => {
      this.doSearch()
    })
  }
  getHeaders = () => {
    // 构建天数范围的表头
    const {dayArr} = this.state;
    headers1 = [];
    headers2 = [];
    showHeaderFlag = []; // 是否显示该天数范围。当value为0或者不存在，就不显示改天数
    dayArr.reduce(function (sum, value) {
      showHeaderFlag.push(value.day * 1 !== 0);
      headers2.push(sum * 1 + value.day * 1);
      headers1.push(sum * 1 + value.day * 1 + 1);
      return sum * 1 + value.day * 1
    }, 0);
    headers1.splice(17, 1);
    headers1.splice(0, 0, 0);
  };
  getNoPraColumn = (ShowTotalNum,sum ,o, index) => {
    //未怀孕的列数据
    let columns = {};
    for (var i = 0; i < 19; i++) {
      let num = i + 1;
      if ( ShowTotalNum[index][i]) {
        columns['column' + num] = (o['w' + num]*1 + o['wo' + num]*1)
      } else {
        columns['column' + num] = ''
      }
    }
    return columns
  };
  getColumn = (ShowTotalNum,sum ,o, index) => {
    let columns = {};
    for (var i = 0; i < 19; i++) {
      let num = i + 1;
      if ( ShowTotalNum[index][i]) {
        columns['column' + num] = o.sow - this.getSum(o, i + 1)
      } else {
        columns['column' + num] = ''
      }
    }
    return columns
  };
  // 未怀孕
  doSearch2 = () => {
    //构建未怀孕的数据。
    // 1 获取header 2 ，构建tableData 3. 构建columns
    // 获取headers
    this.getHeaders();
    let resData = this.state.resData;
    // 梯状图的形成。当配种开始日期距离今天的天数 大于 对应的 header1【i】 就不显示，否则就显示。
    let nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    //showTotalNm是一个二维数据，true显示，false就是不满足上述条件不显示
    let ShowTotalNum = []; // 梯状图的形成。 当像个天数大于表头1的天数，则不显示。
    var mateDateArr = resData.map(function (item) {
      return (new Date(item['week_start_date']))
    });
    mateDateArr.forEach(function (v, i) {
      var iDiffDays = parseInt((nowDate - v) / 1000 / 60 / 60 / 24);
      ShowTotalNum[i] = headers1.map(a => iDiffDays >= a)
    });
    // 构建table的数据源
    let sum = 0; // 母猪累计数量，合计所有配种组的累加母猪数。summary取值。
    let tableData = resData.map((o, index) => {
      // 计算未怀孕的母猪数
      let noFarrow = 0;
      for (var j = 1; j <19; j++) {
        noFarrow += o['w' + j] * 1 + o['wo' + j] * 1
      }
      // 计算summary
      sum = sum + o.sow;
      return {
        mate_group: o.mate_group,
        mate_date: o['week_start_date'] + '-' + o['week_end_date'],
        sow: o.sow,
        farrow: o.farrow,
        farrow_rate:  (o.sow===0)?0:(100 * o.farrow / o.sow).toFixed(2),
        adj_farrow: (o['sow']-o['culled_by_abort']===0) ? 0 : (100*o.farrow/(o['sow']-o['culled_by_abort'])).toFixed(2) ,
        no_farrow: noFarrow,
        expect_farrow: (100 * (o.sow - noFarrow) / o.sow).toFixed(2), // 预计分娩率 =  （母猪数-未怀孕母猪数） / 母猪数
        expect_farrow_date: `${o.exp1}-${o.exp2}`,
        summary: sum,
        ...this.getNoPraColumn(ShowTotalNum,sum,o,index)
      }
    });
    // 添加怀孕三行汇总数据
    let gather = {}; // 汇总 = 母猪数之和 - 未怀孕母猪数
    let noPrangentSowNum = {}; // 未怀孕母猪数;当 为0 则不显示
    let noPrangentDays = {}; // 未怀孕天数： 当 为0 则不显示
    let totalNoPragent = 0;
    for (let i = 1; i < 19; i++) {
      let name = 'column' + i;
      // 计算未怀孕母猪数
      let nums = resData.map((item) => (item['w' + i] * 1 + item['wo' + i] * 1))
        .reduce((acc, cur) => (parseFloat(cur) + acc), 0);
      // 显示未怀孕母猪数
      noPrangentSowNum[name] = nums;
      // 汇总数据
      totalNoPragent += nums;
      gather[name] = resData.reduce((s, o) => s + o.sow, 0) - totalNoPragent;
      // NP 天数
      noPrangentDays[name] = resData.map((item) => (item['diff_abort_date' + i] * 1 + item['diff_cull_date' + i] * 1 + item['diff_tou_date' + i] * 1))
        .reduce((acc, cur) => (parseFloat(cur) + acc), 0);
    }
    // 给table 的数据源添加三行汇总。
    // 汇总： 分娩
    const totalFarrow = tableData.reduce((s, o) => (s + (o.farrow * 1)), 0);
    // 合计母猪数
    const totalSow = tableData.reduce((s, o) => s + o.sow, 0);
    // 分娩率
    const totalFarrowRate =  !!(totalSow === 0) ? 0 : (100  * totalFarrow / totalSow).toFixed(2);
    //汇总 调整分娩率
    let culledSum = resData.map(o => o.culled_by_abort).reduce((s,o) => s+ o, 0);
    const totalAdjFarrow =  (100 * totalFarrow/(totalSow - culledSum)).toFixed(2);
    // 未分娩
    const noFarrow = Object.values(noPrangentSowNum).reduce((s,o) => s + Number(o) ,0);
    tableData.push(
      {
        mate_group: '',
        mate_date: '汇总',
        sow: totalSow,
        summary: '',
        farrow: totalFarrow,
        farrow_rate: totalFarrowRate,
        adj_farrow: totalAdjFarrow,
        no_farrow: noFarrow,
        expect_farrow: (100 * (totalSow - noFarrow) / totalSow).toFixed(2),
        expect_farrow_date: '',
        ...gather
      },
      {
        mate_group: '',
        mate_date: '未怀孕:母猪',
        sow: '',
        summary: '',
        farrow: '',
        farrow_rate: '',
        adj_farrow: '',
        no_farrow: '',
        expect_farrow: '',
        expect_farrow_date: '',
        ...noPrangentSowNum
      },
      {
        mate_group: '',
        mate_date: 'NP天数',
        sow: '',
        summary: '',
        farrow: '',
        farrow_rate: '',
        adj_farrow: '',
        no_farrow: '',
        expect_farrow: '',
        expect_farrow_date: '',
        ...noPrangentDays
      }
    );
    // 构建列数据
    let columns = [
      {
        id: 'mate_group',
        title: '配种组',
        fixed: true,
        align: 'left',
        render (d,index) {
          return <div style={{width: 50}}>{tableData[index].mate_group}</div>
        }
      },
      {
        id: 'mate_date',
        title: '配种时间',
        render (d) {
          return <div style={{width: 80}}>{d.mate_date}</div>
        }
      },
      {
        id: 'sow',
        title: '母猪'
      },
      {
        id: 'summary',
        title: '汇总'
      }
    ];
    for (var i = 0; i < 19; i++) {
      let num = i + 1;
      if (showHeaderFlag[i]) {
        columns.push({
          id: 'column' + num,
          title: `${headers1[i]} - ${headers2[i]}`,
          align: 'center',
          render (d) {
            if (d['column' + num] === 0) {
              return <div style={{width: 60}} />
            } else {
              return <div style={{width: 60}}>{d['column' + num]}</div>
            }
          }
        },)
      }
    }
    columns.push(
      {
        id: 'farrow',
        title: '分娩',
        render (d) {
          if (d.farrow * 1 === 0) {
            return <div style={{width: 40}}/>
          } else  {
            return <div style={{width: 60}}>{d.farrow}</div>
          }
        }
      },
      {
        id: 'farrow_rate',
        title: '分娩率',
        render (d) {
          if (d.farrow_rate * 1 === 0) {
            return <div style={{width: 40}}/>
          } else  {
            return <div style={{width: 60}}>{d.farrow_rate}</div>
          }
        }
      },
      {
        id: 'adj_farrow',
        title: '调整分娩率',
        render (d) {
          if (d.adj_farrow * 1 === 0) {
            return <div style={{width: 60}}/>
          } else  {
            return <div style={{width: 60}}>{d.adj_farrow}</div>
          }
        }
      },
      {
        id: 'no_farrow',
        title: '未分娩',
        render (d) {
          if (d.no_farrow * 1 === 0) {
            return <div style={{width: 60}}/>
          } else  {
            return <div style={{width: 60}}>{d.no_farrow}</div>
          }
        }
      },
      {
        id: 'expect_farrow',
        title: '预计分娩率',
        render (d) {
          return <div style={{width: 70}}>{d.expect_farrow}</div>
        }
      },
      {
        id : 'expect_farrow_date',
        title: '预计分娩日期',
        render (d) {
          return <div style={{width: 80}}>{d.expect_farrow_date}</div>
        }
      }
    );
    this.setState({
      tableData: tableData,
      columns: [...columns]
    })
  };
  //怀孕
  doSearch1 = () => {
    // 1 获取header  2 ，构建tableData 3. 构建columns
    // 1.  获取headers
    this.getHeaders();
    let resData = this.state.resData;
    // 梯状图的形成。当配种开始日期距离今天的天数 大于 对应的 header1【i】 就不显示，否则就显示。
    let nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    // showTotalNm是一个二维数据，true显示，false就是不满足上述条件不显示
    let ShowTotalNum = []; // 梯状图的形成。 当像个天数大于表头1的天数，则不显示。
    var mateDateArr = resData.map(function (item) {
      return (new Date(item['week_start_date']))
    });
    mateDateArr.forEach(function (v, i) {
      var iDiffDays = parseInt((nowDate - v) / 1000 / 60 / 60 / 24);
      ShowTotalNum[i] = headers1.map(a => iDiffDays >= a)
    });
    // 2. 构建table的数据源
    let sum = 0; // 母猪累计数量，合计所有配种组的累加母猪数。summary取值。
    let tableData = resData.map((o, index) => {
      // 计算未怀孕的母猪数
      let noFarrow = 0;
      for (var j = 1; j <19; j++) {
        noFarrow += o['w' + j] * 1 + o['wo' + j] * 1
      }
      // 计算summary
      sum = sum + o.sow;
      return {
        mate_group: o.mate_group,
        mate_date: o['week_start_date'] + '-' + o['week_end_date'],
        sow: o.sow,
        farrow: o.farrow,
        farrow_rate:  (o.sow===0)?0:(100 * o.farrow / o.sow).toFixed(2),
        adj_farrow: (o['sow']-o['culled_by_abort']===0) ? 0 : (100*o.farrow/(o['sow']-o['culled_by_abort'])).toFixed(2) ,
        no_farrow: noFarrow,
        expect_farrow: (100 * (o.sow - noFarrow) / o.sow).toFixed(2), // 预计分娩率 =  （母猪数-未怀孕母猪数） / 母猪数
        expect_farrow_date: `${o.exp1}-${o.exp2}`,
        summary: sum,
        ...this.getColumn(ShowTotalNum,sum,o,index)
      }
    });
    // 添加怀孕三行汇总数据
    let gather = {}; // 汇总 = 母猪数之和 - 未怀孕母猪数
    let noPrangentSowNum = {}; // 未怀孕母猪数;当 为0 则不显示
    let noPrangentDays = {}; // 未怀孕天数： 当 为0 则不显示
    let totalNoPragent = 0;
    for (let i = 1; i < 19; i++) {
      let name = 'column' + i;
      // 计算未怀孕母猪数
      let nums = resData.map((item) => (item['w' + i] * 1 + item['wo' + i] * 1))
        .reduce((acc, cur) => (parseFloat(cur) + acc), 0);
      // 显示未怀孕母猪数
      noPrangentSowNum[name] = nums;
      // 汇总数据
      totalNoPragent += nums;
      gather[name] = resData.reduce((s, o) => s + o.sow, 0) - totalNoPragent;
      // NP 天数
      noPrangentDays[name] = resData.map((item) => (item['diff_abort_date' + i] * 1 + item['diff_cull_date' + i] * 1 + item['diff_tou_date' + i] * 1))
        .reduce((acc, cur) => (parseFloat(cur) + acc), 0);
    }
    // 给table 的数据源添加三行汇总。
    // 汇总： 分娩
    const totalFarrow = tableData.reduce((s, o) => (s + (o.farrow * 1)), 0);
    // 合计母猪数
    const totalSow = tableData.reduce((s, o) => s + o.sow, 0);
    // 分娩率
    const totalFarrowRate =  !!(totalSow === 0) ? 0 : (100  * totalFarrow / totalSow).toFixed(2);
    //汇总 调整分娩率
    let culledSum = resData.map(o => o.culled_by_abort).reduce((s,o) => s+ o, 0);
    const totalAdjFarrow =  (100 * totalFarrow/(totalSow - culledSum)).toFixed(2);
    // 未分娩
    const noFarrow = Object.values(noPrangentSowNum).reduce((s,o) => s + Number(o) ,0);
    tableData.push(
      {
        mate_group: '',
        mate_date: '汇总',
        sow: totalSow,
        summary: '',
        farrow: totalFarrow,
        farrow_rate: totalFarrowRate,
        adj_farrow: totalAdjFarrow,
        no_farrow: noFarrow,
        expect_farrow: (100 * (totalSow - noFarrow) / totalSow).toFixed(2),
        expect_farrow_date: '',
        ...gather
      },
      {
        mate_group: '',
        mate_date: '未怀孕:母猪',
        sow: '',
        summary: '',
        farrow: '',
        farrow_rate: '',
        adj_farrow: '',
        no_farrow: '',
        expect_farrow: '',
        expect_farrow_date: '',
        ...noPrangentSowNum
      },
      {
        mate_group: '',
        mate_date: 'NP天数',
        sow: '',
        summary: '',
        farrow: '',
        farrow_rate: '',
        adj_farrow: '',
        no_farrow: '',
        expect_farrow: '',
        expect_farrow_date: '',
        ...noPrangentDays
      }
    );
    // 2. 构建列数据
    let columns = [
      {
        id: 'mate_group',
        title: '配种组',
        fixed: true,
        align: 'left',
        render (d,index) {
          return <div style={{width: 50}}>{tableData[index].mate_group}</div>
        }
      },
      {
        id: 'mate_date',
        title: '配种时间',
        render (d) {
          return <div style={{width: 80}}>{d.mate_date}</div>
        }
      },
      {
        id: 'sow',
        title: '母猪'
      },
      {
        id: 'summary',
        title: '汇总'
      }
    ];
    for (var i = 0; i < 19; i++) {
      let num = i + 1;
      if (showHeaderFlag[i]) {
        columns.push({
          id: 'column' + num,
          title: `${headers1[i]} - ${headers2[i]}`,
          align: 'center',
          render (d) {
            return <div style={{width: 60}}>{d['column' + num]}</div>
          }
        },)
      }
    }
    columns.push(
      {
      id: 'farrow',
      title: '分娩',
      render (d) {
        if (d.farrow * 1 === 0) {
          return <div style={{width: 40}}/>
        } else  {
          return <div style={{width: 60}}>{d.farrow}</div>
        }
      }
    },
      {
        id: 'farrow_rate',
        title: '分娩率',
        render (d) {
          if (d.farrow_rate * 1 === 0) {
            return <div style={{width: 40}}/>
          } else  {
            return <div style={{width: 60}}>{d.farrow_rate}</div>
          }
        }
      },
      {
        id: 'adj_farrow',
        title: '调整分娩率',
        render (d) {
          if (d.adj_farrow * 1 === 0) {
            return <div style={{width: 60}}/>
          } else  {
            return <div style={{width: 60}}>{d.adj_farrow}</div>
          }
        }
      },
      {
        id: 'no_farrow',
        title: '未分娩',
        render (d) {
          if (d.no_farrow * 1 === 0) {
            return <div style={{width: 60}}/>
          } else  {
            return <div style={{width: 60}}>{d.no_farrow}</div>
          }
        }
      },
      {
        id: 'expect_farrow',
        title: '预计分娩率',
        render (d) {
          return <div style={{width: 70}}>{d.expect_farrow}</div>
        }
      },
      {
        id : 'expect_farrow_date',
        title: '预计分娩日期',
        render (d) {
          return <div style={{width: 80}}>{d.expect_farrow_date}</div>
        }
      }
      );
    this.setState({
      tableData: tableData,
      columns
    })
  };
  doSearch = () => {
    // 在dosearch 中只负责获取导数据，当怀孕和未怀孕时候，数据显示不同，怀孕在dosearch1 ，未怀孕在 dosearch2
    // 收到数据后传递到对应的渲染中处理数据。
    Toast.loading('加载中', 30);
    this.getHeaders();
    const {startWeek, endWeek, parity, parGestation, selectedBreeder} = this.state;
    let start = startWeek;
    let end = endWeek;
    if (startWeek > endWeek) {
      start = endWeek;
      end = startWeek;
      this.setState({startWeek: start, endWeek: end})
    }
    let params = {};
    for (var i = 1; i < 19; i++) {
      params['parDays'+i] = headers2[i-1]
    }
    send({
      url: '/api/forward/ifarm/report4',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        ...params,
        parGestation, // 怀孕天数
        mateGroup1: startWeek * 1,
        mateGroup2: endWeek * 1,
        parity, // 全部ALL 第一胎 FIRST
        breeder: selectedBreeder.toString()
      }
    }).then(res => {
      Toast.hide();
      if (res.status !== 200) {
        return
      }
      let resData = res.data;
      this.setState({
        resData
      }, () => {
        Toast.hide();
        if (this.state.status === 'pregnant') {
          this.doSearch1(resData)
        } else if (this.state.status === 'noPregnant') {
          this.doSearch2(resData)
        }
      })
    })
  };
  getSum = (data, i) => {
    var sumw = 0;
    for (let j = 1; j <= i; j++) {
      sumw += data['w' + j] * 1 + data['wo' + j] * 1
    }
    return sumw
  };
  render() {
    const {showBreeder, showStart, showEnd, startWeek, endWeek, selectedBreeder, status, parGestation, parity} = this.state;
  return (
    <div className="oneH">
      <Flex className={(showBreeder || showStart || showEnd)? 'single-multi-menu-active' : ''}>
        <div className={'single-multi-top-nav-bar list-1'}
            style={{width: '60px',paddingLeft: 8}}
            onClick={() => {
               this.setState({
                 showBreeder: !showBreeder,
                 showStart: false,
                 showEnd: false
               })
             }}
        >
          <LinkText show={showBreeder}>品种</LinkText>
        </div>
        <div className={'single-multi-top-nav-bar list-1'}
            style={{width: '125px'}}
            onClick={() => {
               this.setState({
                 showBreeder: false,
                 showStart: !showStart,
                 showEnd: false
               })
             }}
        >
          <LinkText show={showStart}>配种组开始时间</LinkText>
        </div>
        <div className={'single-multi-top-nav-bar list-1'}
            style={{width: 'calc(100vw - 193px)'}}
            onClick={() => {
               this.setState({
                 showBreeder: false,
                 showStart: false,
                 showEnd: !showEnd
               })
             }}
        >
          <LinkText show={showEnd}>配种组截止时间</LinkText>
        </div>
      </Flex>
      {
        showBreeder ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
          <Breeder data={breedersSource}
              onCancel={this.onCancel}
              onConfirm={(value, desc) => {
                     this.setState({
                       showBreeder: false,
                       selectedBreeder: value,
                       allBreed: desc
                     }, () => {
                       this.doSearch()
                     });
                   }}
              value={selectedBreeder}
          />
        </div>: null
      }
      {
        showStart ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
          <MateGroup data={birthWeekSource}
              onCancel={() => {
                       this.setState({
                         showStart: false
                       })}
                     }
              onConfirm={(value, data) => {
                       this.setState({
                         startWeek: value,
                         startDate: data.weekStartDate,
                         showStart: false
                       }, () => {
                         this.doSearch()
                       })
                     }}
              value={startWeek}
          />
        </div>: null
      }

      {
        showEnd ? <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
          <MateGroup data={birthWeekSource}
              onCancel={() => {
                       this.setState({
                         showEnd: false
                       })}
                     }
              onConfirm={(value, data) => {
                       this.setState({
                         endWeek: value,
                         endDate: data.weekEndDate,
                         showEnd: false
                       }, () => {
                         this.doSearch()
                       })
                     }}
              value={endWeek}
          />
        </div>: null
      }

      <List>
        <List.Item
          className="span-4"
          disabled
          extra={this.state.startDate + ' ~ ' + this.state.endDate}
        >
          时间范围
        </List.Item>
        <List.Item extra={
          <Stepper
              className={'stepper-round'}
              style={{ width: '100%', minWidth: '100px' }}
              showNumber
              min={0}
              defaultValue={parGestation}
              onChange={v => {
                this.setState({
                  parGestation: parseInt(v)
                }, () => {
                  this.doSearch()
                })
              }}
          />}
        >
          怀孕天数
        </List.Item>
        <List.Item
            className={'span-3'}
            extra={<Flex>
            <Flex.Item>
              <Radio className="my-radio"
                  checked={parity === 'ALL'}
                  onChange={() => {
                       this.setState({
                         parity: 'ALL'
                       }, () => {
                         this.doSearch()
                       })
                     }}
              >全部</Radio>
            </Flex.Item>
            <Flex.Item>
              <Radio className="my-radio"
                  checked={parity === 'FIRST'}
                  onChange={() => {
                       this.setState({
                         parity: 'FIRST'
                       }, () => {
                         this.doSearch()
                       })
                     }}
              >第一胎</Radio>
            </Flex.Item>
        </Flex>}
        >
          胎次
        </List.Item>
        <List.Item
            className={'span-3'}
            extra={<Flex>
            <Flex.Item>
              <Radio className="my-radio"
                  checked={status === 'pregnant'}
                  onClick={() => {
                       this.setState({
                         status: 'pregnant'
                       })
                     }}
                  onChange={() => {
                       // 无需请求数据，渲染怀孕的表格。
                       this.doSearch1()
                     }}
              >怀孕</Radio>
            </Flex.Item>
            <Flex.Item>
              <Radio className="my-radio"
                  checked={status === 'noPregnant'}
                  onClick={() => {
                       this.setState({
                         status: 'noPregnant'
                       })
                     }}
                  onChange={() => {
                       // 渲染未怀孕表格。此时数据不重新请求，而是利用元数据前端做计算。
                       this.doSearch2()
                     }}
              >未怀孕</Radio>
            </Flex.Item>
          </Flex>}
        >
          状态
        </List.Item>
        <List.Item extra={
          <Stepper
              className={'stepper-round'}
              style={{ width: '100%', minWidth: '100px' }}
              showNumber
              max={115}
              min={1}
              defaultValue={7}
              onChange={v => {
              let day = parseInt(v);
              this.setState({
                day,
                dayArr: new Array(18).fill({day})
              }, () => {
                this.doSearch()
              })
            }}
          />}
        >
          间隔天数
        </List.Item>
      </List>

      {
        (showBreeder || showStart || showEnd) && <div className={'mask'}/>
      }
      {
        (this.state.resData.length) ? <Table
            columns={this.state.columns}
            data={this.state.tableData}
                                      /> :
          <EmptyReport height={250} />

      }
    </div>
  )
 }
}
